import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-success-dialog',
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.scss'],
})
export class SuccessDialogModalComponent {
  text: string;
  subtext: string;
  btntext: string;

  constructor(
    public dialogRef: MatDialogRef<SuccessDialogModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.text = data.texts.text;
    this.subtext = data.texts.subtext;
    this.btntext = data.texts.btntext;
  }

  closeModal() {
    this.dialogRef.close();
  }
}
